import styled from 'styled-components';

import squaresBg from '../../assets/images/squares-small.png';

export default styled.div`
  display: flex;
  flex-direction: column;

  min-height: 100vh;

  background: url(${squaresBg});

  > header {
    flex: 0 0 auto;
  }

  > main {
    flex: 1 1 auto;

    position: relative;

    ${props => props.theme.breakpoints.up('xs')} {
      margin: 2rem;
    }

    ${props => props.theme.breakpoints.up('sm')} {
      margin: 2rem 3rem;
    }
  }

  > footer {
    flex: 0 0 auto;
  }
`;
